import React from 'react';
import styled from 'styled-components';

import { colors } from '../../healtheraComponents';
import { formatDateTimeHumanFriendly } from '../../utils/formatters';

const Note = ({ title, small, withPadding, note }) => {
  if (!note) {
    return null;
  }

  const { text, date_created } = note;

  return (
    <NoteContainer small={small} withPadding={withPadding}>
      <NoteTitle>
        {title && `${title}: `}
        {formatDateTimeHumanFriendly(date_created * 1000)}
      </NoteTitle>
      <NoteContent>{text}</NoteContent>
    </NoteContainer>
  );
};

const NoteContainer = styled.div`
  padding: ${props => (props.withPadding ? '16px' : '')};
  font-family: 'SFProRegular';
  font-size: ${props => (props.small ? '12px' : '14px')};
  background-color: #f9f9f9;
`;

const NoteTitle = styled.p`
  margin: 0;
  color: #666666;
`;

const NoteContent = styled.p`
  color: ${colors.DARK};
`;

export default Note;
